import { render, staticRenderFns } from "./CategoriesFilter.vue?vue&type=template&id=007a3014&scoped=true&"
import script from "./CategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFilter.vue?vue&type=style&index=0&id=007a3014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a3014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007a3014')) {
      api.createRecord('007a3014', component.options)
    } else {
      api.reload('007a3014', component.options)
    }
    module.hot.accept("./CategoriesFilter.vue?vue&type=template&id=007a3014&scoped=true&", function () {
      api.rerender('007a3014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Filters/CategoriesFilter.vue"
export default component.exports